import { socket } from "../../../api"
import { Character } from "../../../types"
import { DialogueMessage } from "../../../types/LogicTypes"
import AppModal from "../../Common/AppModal"
import { getDialogueSubtitle, renderDiceRoll } from "../helpers/uiHelpers"

type Props = {
    character: Character | undefined
}
const Dialogue: React.FC<Props> = (props) => {

    const interactWithDialogue = (actionId: string) => {
        if (props.character?.dialogueStatus.npcId) {
            socket.emit("intWithNpc", {npcId: props.character?.dialogueStatus.npcId, actionId: actionId})
            return
        }
        socket.emit("intWithDialogue", { actionId: actionId })
    }

    return (
        <AppModal name="interaction" title={props.character?.dialogueStatus.title ?? ""} subtitle={getDialogueSubtitle(props.character?.dialogueStatus)} preventClosing>
            <div className="mb-3">
                { props.character?.dialogueStatus.messages.map((m, i) => <Message key={i} m={m} interact={interactWithDialogue} />) }
            </div>
        </AppModal>
    )
}

type MessageProps = {
    m: DialogueMessage
    interact: (actionId: string) => void
}
const Message: React.FC<MessageProps> = (props) => {
    if (props.m.type === "action") {
        if (props.m.actionTriggered) {
            return <div className="px-4 py-2 muted strong italic"><strong>{props.m.message}</strong></div>
        }
        return (
            <div className="px-4 py-2 clickable strong italic" onClick={() => { props.m.id && props.interact(props.m.id) }}>
                <strong>&raquo; {props.m.message}</strong>
            </div>
        )
    }
    if (props.m.type === "dieRoll" && props.m.dieRoll) {
        return <div className={"p-2 " + (props.m.messageStyle ?? "")}>Test result: {renderDiceRoll(props.m.dieRoll)} - {props.m.dieRollSuccess ? "Success" : "Fail"}</div>
    }
    if (props.m.type === "message") {
        return <div className={"p-2 " + (props.m.messageStyle ?? "")}>{props.m.message}</div>
    }
    return <></>
}

export default Dialogue